import styled from '@emotion/styled'
import image from '../assets/loading.svg'

const Container = styled.div`
  position: absolute;
  width: 100%;
  z-index: 100000000;
  background: white;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 100vh;

  .circle {
    width: 45px;
    height: 45px;
    border-radius: 50%;
  }

  .pulse {
    animation: pulse-animation 1s infinite ease-in-out;
  }

  @keyframes pulse-animation {
    0% {
      box-shadow: 0 0 0 0px rgb(236, 239, 242);
    }

    100% {
      box-shadow: 0 0 0 20px rgb(252, 252, 255);
    }
  }
`

export const LoadingPulse = () => {
  return (
    <Container>
      <img
        className="circle pulse"
        src={image}
        width={45}
        height={45}
        alt="loading"
      />
    </Container>
  )
}
